import { render } from "./LeftComponent.vue?vue&type=template&id=df627da6&scoped=true"
import script from "./LeftComponent.vue?vue&type=script&lang=js"
export * from "./LeftComponent.vue?vue&type=script&lang=js"

import "./LeftComponent.vue?vue&type=style&index=0&id=df627da6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df627da6"]])

export default __exports__